import axios from 'axios';
import StorageService from 'common/services/StorageService';
import StorageConst from 'consts/StorageConst';
import UrlConst from 'consts/UrlConst';
import Configs from 'utils/Configs';
import Funcs from './Funcs';

let api;

function getHosts() {
  if (Configs.mode !== 'prod') return [UrlConst.API];
  const isVN = Configs.timezone === 'Asia/Ho_Chi_Minh' || Configs.timezone === 'Asia/Saigon' || Configs.countryCode?.toLowerCase() === 'vn';
  if (Configs.hostType === 1 || (Configs.hostType == null && !isVN)) return [...UrlConst.SG_HOSTS, ...UrlConst.VN1_HOSTS, ...UrlConst.VN2_HOSTS];
  if (Configs.hostType === 2) return [...UrlConst.VN2_HOSTS, ...UrlConst.SG_HOSTS, ...UrlConst.VN1_HOSTS];
  return [...UrlConst.VN1_HOSTS, ...UrlConst.SG_HOSTS, ...UrlConst.VN2_HOSTS];
}

function apply() {
  if (api) api.defaults.baseURL = getHosts()[0];
  UrlConst.API = getHosts()[0];
}

async function retryMasterWhenSlaveUnavailable(instance, error, config) {
  const data = error.response?.data;
  if (error.response?.status !== 503 || data?.code !== 'MASTER_UNAVAILABLE' || data?.role !== 'slave' || config.apiHostMasterRetry) return null;

  const hosts = getHosts().filter((host) => host !== config.baseURL);
  for (let index = 0; index < hosts.length; index += 1) {
    const host = hosts[index];
    try {
      Funcs.log('Try master failover to host', host);
      const response = await instance.get('health', { baseURL: host, timeout: 2000, apiHostHealthCheck: true });
      if (response.data?.role !== 'master') continue;

      Funcs.log('API MASTER FAILOVER', config.baseURL, '->', host);
      instance.defaults.baseURL = host;
      UrlConst.API = host;
      config = { ...config, baseURL: host, timeout: 5000, apiHostMasterRetry: true };
      return instance(config);
    } catch (err) {
      Funcs.log('API MASTER HEALTH CHECK FAILED', host, err?.message);
    }
  }
  return null;
}

function bind(instance) {
  api = instance;
  apply();
  instance.interceptors.response.use(null, async (error) => {
    const config = error.config || {};
    const forceFailover = config.headers?.forceFailover;
    const isSafeMethod = ['get', 'head', 'options'].indexOf(config.method?.toLowerCase()) >= 0;
    const shouldSkipFailover = config.headers?.skipFailover || (!forceFailover && !isSafeMethod);
    if (axios.isCancel(error) || config.baseURL === '' || config.apiHostHealthCheck || shouldSkipFailover) return Promise.reject(error);
    const masterRetry = await retryMasterWhenSlaveUnavailable(instance, error, config);
    if (masterRetry) return masterRetry;
    if (!forceFailover && error.response && [502, 504].indexOf(error.response.status) < 0) return Promise.reject(error);

    const hosts = getHosts();
    const current = config.baseURL;
    const next = hosts[hosts.indexOf(current) + 1];
    if (!next) {
      instance.defaults.baseURL = hosts[0];
      UrlConst.API = hosts[0];
      return Promise.reject(error);
    }
    if (config.apiHostRetryCount >= hosts.length - 1) return Promise.reject(error);

    Funcs.log('API FAILOVER', current, '->', next);
    instance.defaults.baseURL = next;
    UrlConst.API = next;
    config.baseURL = next;
    config.timeout = 5000;
    config.apiHostRetryCount = (config.apiHostRetryCount || 0) + 1;
    return instance(config);
  });
}

async function load() {
  let hostType = await StorageService.get(StorageConst.HOST_TYPE);
  if (hostType !== 0 && hostType !== 1 && hostType !== 2) hostType = null;
  Configs.hostType = hostType;
  apply();
}

export default { apply, bind, load };
